module.exports = __webpack_public_path__ + "images/FUSA_icons/043-online-shop-6.99ab7fb516f9c91b68d4b7a976fce183.svg";